import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionBabySeat"
const OptionBabySeatIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="m7.1700885 21.0000885h12.33c.552 0 1-.448 1-1s-.448-1-1-1l-10.669.004-2.848-15.188c-.102-.543-.625-.9-1.167-.799-.543.102-.9.625-.799 1.167zm2.344-3.835-1.5-9c-.086-.515.238-1.009.743-1.135 1.623-.406 2.749-.244 3.413.654.47.634.535 1.177.537 2.67.001.662.009.961.046 1.317.1.96.395 1.599 1.029 2.075.529.397.818.344 1.676-.206.98-.628 1.249-.767 1.884-.779.786-.016 1.448.416 1.99 1.23.171.257.214.578.117.871l-.819 2.454c-.135.409-.518.684-.948.684h-7.182c-.489 0-.906-.354-.986-.835z" />
        </svg>
      }
    </span>
  )
}
export default OptionBabySeatIcon
